import sortBy from 'lodash/sortBy';

import { types as actions } from '../actions';

const defaultState = {
  list: [],
  map: {},
  currentGroup: {},
  filter: ''
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.GET_AREAS:
      return {
        ...defaultState
      };
    case actions.SET_GROUPS:
      return {
        list: sortBy(action.groups, [group => group.name.toLowerCase()]),
        map: action.groups.reduce(
          (map, group) => ({ ...map, [group.id]: group }),
          {}
        )
      };
    case actions.ADDED_GROUP: {
      return {
        list: sortBy([...state.list, action.group], [group => group.name.toLowerCase()]),
        map: {
          ...state.map,
          [action.group.id]: action.group
        }
      };
    }
    case actions.SET_CURRENT_GROUP: {
      return {
        ...state,
        currentGroup: action.group
      };
    }
    case actions.EDITED_GROUP: {
      const groupList = state.list.map(group => {
        if (group.id === action.group.id) {
          group = action.group;
        }
        return group;
      });
      return {
        list: sortBy(groupList, [group => group.name.toLowerCase()]),
        map: {
          ...state.map,
          [action.group.id]: action.group
        }
      };
    }
    case actions.REMOVE_GROUP: {
      const groupList = state.list.filter(group => {
        return group.id !== action.groupId;
      });
      delete state.map[action.groupId];
      return {
        ...state,
        list: groupList
      };
    }
    case actions.FILTER_GROUP: {
      return {
        ...state,
        filter: action.searchText
      };
    }
    case actions.LOGGED_OUT:
      return defaultState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/groups/index.js